import { render, staticRenderFns } from "./RepaymentSelectSkeleton.vue?vue&type=template&id=27cf165e&scoped=true"
import script from "./RepaymentSelectSkeleton.vue?vue&type=script&lang=js"
export * from "./RepaymentSelectSkeleton.vue?vue&type=script&lang=js"
import style0 from "./RepaymentSelectSkeleton.vue?vue&type=style&index=0&id=27cf165e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cf165e",
  null
  
)

export default component.exports